import { useCart } from "@/context/CartContext";
import { Link } from "react-router-dom";
import { X, Plus, Minus, Trash } from "@phosphor-icons/react";

export default function CartDrawer() {
  const { items, open, setOpen, update, remove, subtotal } = useCart();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex" data-testid="cart-drawer">
      <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
      <aside className="w-full max-w-md bg-white border-l border-zinc-900 flex flex-col">
        <div className="flex items-center justify-between border-b border-zinc-900 px-5 py-4">
          <div className="font-[Outfit] font-black uppercase tracking-tighter text-xl">Your Cart</div>
          <button data-testid="cart-close" onClick={() => setOpen(false)} className="p-2 hover:bg-zinc-900 hover:text-white"><X size={18} weight="bold" /></button>
        </div>
        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-8 text-center text-sm text-zinc-500 uppercase tracking-widest font-[Outfit] font-bold">Cart is empty</div>
          ) : items.map(i => (
            <div key={i.product_id} className="flex gap-3 p-4 border-b border-zinc-200" data-testid={`cart-line-${i.product_id}`}>
              <div className="w-16 h-16 bg-zinc-100 border border-zinc-900 flex-shrink-0 flex items-center justify-center overflow-hidden">
                {i.image && <img src={i.image} alt={i.title} className="w-full h-full object-contain p-1" />}
              </div>
              <div className="flex-1">
                <div className="text-xs font-semibold leading-tight line-clamp-2">{i.title}</div>
                <div className="text-sm font-black font-[Outfit] mt-1">${(i.price * i.quantity).toFixed(2)}</div>
                <div className="flex items-center gap-2 mt-2">
                  <button data-testid={`qty-dec-${i.product_id}`} onClick={() => update(i.product_id, i.quantity - 1)} className="w-9 h-9 md:w-7 md:h-7 border border-zinc-900 flex items-center justify-center hover:bg-zinc-900 hover:text-white"><Minus size={12} weight="bold" /></button>
                  <span className="text-sm font-bold w-6 text-center">{i.quantity}</span>
                  <button data-testid={`qty-inc-${i.product_id}`} onClick={() => update(i.product_id, i.quantity + 1)} className="w-9 h-9 md:w-7 md:h-7 border border-zinc-900 flex items-center justify-center hover:bg-zinc-900 hover:text-white"><Plus size={12} weight="bold" /></button>
                  <button data-testid={`cart-remove-${i.product_id}`} onClick={() => remove(i.product_id)} className="ml-auto w-9 h-9 md:w-7 md:h-7 border border-zinc-900 flex items-center justify-center hover:bg-[#ff3333] hover:border-[#ff3333] hover:text-white"><Trash size={12} weight="bold" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-zinc-900 p-5 pb-20 md:pb-5 space-y-3">
          <div className="flex justify-between text-sm uppercase tracking-widest font-[Outfit] font-bold">
            <span>Subtotal</span>
            <span data-testid="cart-subtotal">${subtotal.toFixed(2)} NZD</span>
          </div>
          <Link
            data-testid="cart-checkout-btn"
            to="/checkout"
            onClick={() => setOpen(false)}
            className={`btn-brutal btn-red w-full ${items.length === 0 ? "pointer-events-none opacity-40" : ""}`}
          >
            Checkout →
          </Link>
        </div>
      </aside>
    </div>
  );
}
